module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAPBAMAAAAmOuNHAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAADBQTFRFAAAAmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZsvyjQQAAABB0Uk5TACIzqu7/u2Z3mYgRRMzdVfKUL0UAAAB8SURBVHicY2BgYBBkAAEmk9AwBSBdGtw+JYqBgT1sw27uqQ0MWxK4XQSYgxiWKjCGHuCOZLjLwNjBwJDH8JiBM3QDw1SGZwyMoQIMpgwmDNyhCgxvGb42cIYm8IczsPkwlR8QucDA/XQhg4SLAAPD5lCX0ESQRRIzmxgYADPjG/URh5ftAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_warning.png
// module id = hVrJ
// module chunks = 0